class HeroSlideshow {
  constructor(sectionElement) {
    this.section = sectionElement;
    this.carousel = this.section.querySelector('.js-hero-slideshow-carousel');
    if (!this.carousel) return;

    this.init();
  }

  init() {
    const options = JSON.parse(this.carousel.dataset.flickityOptions || '{}');
    
    // Convert autoplay speed from seconds to milliseconds if it's greater than 0
    if (options.autoPlay && options.autoPlay > 0) {
      // Flickity expects boolean `true` for autoplay or a number in ms.
    } else {
      options.autoPlay = false;
    }
    
    this.flickity = new Flickity(this.carousel, options);
  }

  onSectionUnload() {
    if (this.flickity) {
      this.flickity.destroy();
    }
  }
}

// Register the section with Shopify's theme editor
document.addEventListener('shopify:section:load', (event) => {
  const sectionElement = event.target;
  if (sectionElement.dataset.sectionType === 'hero-slideshow') {
    new HeroSlideshow(sectionElement);
  }
});

// Handle section unload for theme editor changes
document.addEventListener('shopify:section:unload', (event) => {
    const sectionElement = event.target;
    if (sectionElement.dataset.sectionType === 'hero-slideshow' && sectionElement.slideshowInstance) {
        sectionElement.slideshowInstance.onSectionUnload();
    }
});

// Initial load for sections already on the page
document.querySelectorAll('[data-section-type="hero-slideshow"]').forEach(sectionElement => {
    if (!sectionElement.slideshowInstance) {
        sectionElement.slideshowInstance = new HeroSlideshow(sectionElement);
    }
});